import { render, staticRenderFns } from "./ResultadosInfoCard.vue?vue&type=template&id=867ec33e"
import script from "./ResultadosInfoCard.vue?vue&type=script&lang=js"
export * from "./ResultadosInfoCard.vue?vue&type=script&lang=js"
import style0 from "./ResultadosInfoCard.vue?vue&type=style&index=0&id=867ec33e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports